import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Response } from '../../shared/models/response.model';
import { Groupe } from '../models/groupe.model';
import { GroupeCreateRequest } from '../requests/groupe-create-request';
import { GroupeUpdateRequest } from '../requests/groupe-update-request';

@Injectable({
  providedIn: 'root',
})
export class GroupeService {
  #http = inject(HttpClient);

  readonly BASE_URL = `/groupes`;

  findAll(idReferentiel: string) {
    return this.#http.get<Response<Groupe>>(this.BASE_URL, { params: { idReferentiel } });
  }

  findById(idGroupe: string): Observable<Groupe> {
    return this.#http.get<Groupe>(this.BASE_URL + '/' + idGroupe);
  }

  créer(data: GroupeCreateRequest) {
    return this.#http.post<void>(this.BASE_URL, data);
  }

  modifier(id: string, data: GroupeUpdateRequest) {
    return this.#http.put(this.BASE_URL + '/' + id, data);
  }

  supprimer(idGroupe: string) {
    return this.#http.delete<void>(this.BASE_URL + '/' + idGroupe);
  }
}
